module.exports = __webpack_public_path__ + "static/szenario1-9083f932b7e6ec6569e96b3d0b750049.png";